import React from 'react'
import Link from '../Link'
import Button from '../Button/index'

import {
  rightArrow,
  textCtaContainer,
  textCtaWrapper,
  titleText,
  linkStyle,
  body,
} from './index.module.css'

const TextWithCTA = ({ components, backgroundColor }) => {
  const component = components?.[0]
  if (!component) {
    return <div className={textCtaContainer} style={{ backgroundColor }} />
  }

  const { title, subtitle, ctaUrl, ctaText, ctaDefaultDisplay } = component

  const renderLink = () =>
    ctaDefaultDisplay ? (
      <span>
        {ctaText} <i className={rightArrow} />
      </span>
    ) : (
      <Button inverted>
        <span>
          {ctaText} <i className={rightArrow} />
        </span>
      </Button>
    )

  return (
    <div className={textCtaContainer} style={{ backgroundColor }}>
      <div className={textCtaWrapper}>
        <h2 className={titleText}>{title}</h2>
        <p className={body}>{subtitle.subtitle}</p>
        {ctaText && (
          <Link className={linkStyle} to={ctaUrl}>
            {renderLink()}
          </Link>
        )}
      </div>
    </div>
  )
}

export default TextWithCTA
